import React from 'react'
import { Col, Row } from 'react-bootstrap';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    Title,
    Tooltip,
    Legend,
  } from 'chart.js';
  import { Bar } from 'react-chartjs-2';


  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

function LineGraphSummary(props) {
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: props.title || 'Payment Hits by Period',
      },
    },
  };

  const data = {
    labels:props.labels,
    datasets: [
      {
        label: 'All',
        data: props.data,
        borderColor: 'rgb(255, 99, 132)',
        backgroundColor: 'rgba(255, 99, 132, 0.8)',
      },
    ],
  };
  return (
    <div>
        <Row>
            <Col>
                <Bar options={options} data={data} />
            </Col>
        </Row>
    </div>
  )
}

export default LineGraphSummary